import * as React from "react";
import { forwardRef } from "react";
const SvgShow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M.2 10a11 11 0 0 1 19.6 0A11 11 0 0 1 .2 10zm9.8 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" }));
const ForwardRef = forwardRef(SvgShow);
export { ForwardRef as ReactComponent };
